// src/pages/AdhisuchanaPage.jsx
import React from "react";

const adhisuchanaData = [
  {
    title: "पंचायत समिती सभापती पदाचे आरक्षणाबाबत.",
    date: "17/09/2025",
    file: "10MB",
  },
  {
    title: "अधिसूचना दिनांक 9 सप्टेंबर 2025 जिल्हा परिषद अध्यक्ष, पंचायत समिती सभापती आरक्षणाबाबत",
    date: "09/09/2025",
    file: "405KB",
  },
  {
    title: "केंद्रप्रमुख सेवाप्रवेश नियम सुधारित अधिसूचना 18.7.2025",
    date: "18/07/2025",
    file: "265KB",
  },
  {
    title: "रामटेक तालुक्यातील पांचाळा (बुद्रुक) ग्रामपंचायतीचे विभाजन आणि गुगुलडोह या महसूली गावासाठी स्वतंत्र ग्रामपंचायत स्थापन करण्याबाबत.",
    date: "17/06/2025",
    file: "235KB",
  },
  {
    title: "अधिसूचना- सरपंच आरक्षण निश्चित करण्याबाबत..",
    date: "13/06/2025",
    file: "2MB",
  },
  {
    title: "ग्रामपंचायत आर्वी-अनगरे, ता.श्रीगोंदा, जि.अहिल्यानगर मधुन आर्वी या महसुली गावाची स्वतंत्र ग्रामपंचायत स्थापन करणेबाबत.",
    date: "06/05/2025",
    file: "287KB",
  },
  {
    title: "ग्रामपंचायत डोळंबा, ता.डिग्रस, जि.यवतमाळ मधून डोळंबवाडी या महसुली गावाची स्वतंत्र ग्रामपंचायत स्थापन करणेबाबत.",
    date: "06/05/2025",
    file: "236KB",
  },
  {
    title: "ग्रामपंचायत निमगाव (टे), ता.माढा, जि.सोलापूर मधुन बादलेवाडी या महसुली गावाची स्वतंत्र ग्रामपंचायत स्थापन करणेबाबत.",
    date: "15/04/2025",
    file: "272KB",
  },
  {
    title: "अहमदनगरचे नाव बदलून अहिल्यानगर असे करण्याबाबत अधिसूचना",
    date: "13/03/2025",
    file: "235KB",
  },
  {
    title: "ग्रामपंचायत बोरीबेल, ता.दौंड जि.पुणे मधून गाडेवाडी या महसुली गावाची स्वतंत्र ग्रामपंचायत स्थापन करणेबाबत.",
    date: "10/02/2025",
    file: "224KB",
  },
  // बाकी data इथल्या प्रमाणे add करू शकता
];

export default function AdhisuchanaPage() {
  return (
    <div className="max-w-6xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">अधिसूचना</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200 rounded-lg">
          <thead className="bg-custom-orange text-white">
            <tr>
              <th className="px-4 py-2 text-left">शीर्षक</th>
              <th className="px-4 py-2 text-left">तारीख</th>
              <th className="px-4 py-2 text-left">पहा / डाउनलोड करा</th>
            </tr>
          </thead>
          <tbody>
            {adhisuchanaData.map((item, index) => (
              <tr
                key={index}
                className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
              >
                <td className="px-4 py-2">{item.title}</td>
                <td className="px-4 py-2">{item.date}</td>
                <td className="px-4 py-2">
                  <a
                    href="#"
                    className="text-blue-600 hover:underline"
                  >
                    पहा ({item.file})
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
